import React from 'react';
import InputBase from './input_base';
import { FAIcon } from 'reactifi';

export default class MaterialFormElement extends InputBase {

  renderFormGroup = (children) => {
    var props;
    if(this.props.groupClassName){
      props = Object.assign({}, this.props, { className: this.props.groupClassName });
    }else{
      props = this.props;
    }

    return React.createElement(
      'div',
      props,
      children
    );
  };

  get disabledByLocaleClass() {
    return this.props.disabledByLocale ? 'disabled' : '';
  }

  renderInputHelper = () => {
    if(this.props.includeInputHelper) {
      return <i className="input-helper"/>
    }
  };

  renderCheckboxAndRadioWrapper = (children) => {
    const { type } = this.props;

    return React.createElement(
      'div',
      { className: `${type === 'checkbox' ? 'checkbox ' : ''}${type === 'radio' ? 'radio ' : ''} ${this.disabledByLocaleClass}`, key: 'checkboxRadioWrapper' },
      children
    );
  };

  getInputDOMNode = () => {
    return this.refs.input;
  };

  getValue = () => {
    if (this.props.type === 'static') {
      return this.props.value;
    } else if (this.props.type) {
      if (this.props.type === 'select' && this.props.multiple) {
        return this.getSelectedOptions();
      }
      return this.getInputDOMNode().value;
    }
    throw new Error('Cannot use getValue without specifying input type.');
  };

  getChecked = () => {
    return this.getInputDOMNode().checked;
  };

  getSelectedOptions = () => {
    let values = [];

    Array.prototype.forEach.call(
      this.getInputDOMNode().getElementsByTagName('option'),
      (option) => {
        if (option.selected) {
          let value = option.getAttribute('value') || option.innerHtml;
          values.push(value);
        }
      });

    return values;
  };

  isCheckboxOrRadio = () => {
    return this.props.type === 'checkbox' || this.props.type === 'radio';
  };

  isFile = () => {
    return this.props.type === 'file';
  };

  renderInputGroup = (children) => {
    let addonBefore = this.props.addonBefore ? (
      <span className="input-group-addon" key="addonBefore">
        {this.props.addonBefore}
      </span>
    ) : null;

    let addonAfter = this.props.addonAfter ? (
      <span className="input-group-addon" key="addonAfter">
        {this.props.addonAfter}
      </span>
    ) : null;

    let buttonBefore = this.props.buttonBefore ? (
      <span className="input-group-btn">
        {this.props.buttonBefore}
      </span>
    ) : null;

    let buttonAfter = this.props.buttonAfter ? (
      <span className="input-group-btn">
        {this.props.buttonAfter}
      </span>
    ) : null;

    let inputGroupClassName;
    switch (this.props.bsSize) {
    case 'small': inputGroupClassName = 'input-group-sm'; break;
    case 'large': inputGroupClassName = 'input-group-lg'; break;
    default:
    }

    return addonBefore || addonAfter || buttonBefore || buttonAfter ? (
      <div className={`${inputGroupClassName} input-group`} key="input-group">
        {addonBefore}
        {buttonBefore}
        {children}
        {addonAfter}
        {buttonAfter}
      </div>
    ) : children;
  };

  renderIcon = () => {
    if (this.props.hasFeedback) {
      if (this.props.feedbackIcon) {
        return React.cloneElement(this.props.feedbackIcon, { formControlFeedback: true });
      }

      switch (this.props.bsStyle) {
      case 'success': return  <FAIcon icon="circle-check" />
      case 'warning': return  <FAIcon icon="triangle-exclamation" />
      case 'error': return <FAIcon icon="circle-exclamation" />
      default: return <span className="form-control-feedback" key="icon" />;
      }
    } else {
      return null;
    }
  };

  renderHelp = () => {
    return this.props.help ? (
      <span className="form-text" key="help">
        {this.props.help}
      </span>
    ) : null;
  };

  renderWrapper = (children) => {
    return this.props.wrapperClassName ? (
      <div className={this.props.wrapperClassName} key="wrapper">
        {children}
      </div>
    ) : children;
  };

  renderLabel = (children) => {
    return this.props.label ? (
      <label htmlFor={this.props.id} className={`${!this.isCheckboxOrRadio() ? 'form-label ' : ''}${this.props.labelClassName}`} key="label">
        {children}
        {this.props.label}
      </label>
    ) : children;
  };

  renderInput = () => {
    if (!this.props.type) {
      return this.props.children;
    }
    const { className } = this.props;
    switch (this.props.type) {
    case 'select':
      return (
        <select {...this.props} className={`${className} form-control`} ref="input" key="input">
          {this.props.children}
        </select>
      );
    case 'textarea':
      return <textarea {...this.props} className={`${className} form-control`} ref="input" key="input" />;
    case 'static':
      return (
        <p {...this.props} className={`${className} form-control-plaintext`} ref="input" key="input">
          {this.props.value}
        </p>
      );
    default: {
      const formClassName = this.isCheckboxOrRadio() || this.isFile() ? '' : 'form-control';
      return <input {...this.props} className={`${className} ${formClassName}`} ref="input" key="input" />;
    }
    }
  };

  renderChildren = () => {
    return !this.isCheckboxOrRadio() ? [
      this.renderLabel(),
      this.renderWrapper([
        this.renderInputGroup(
          this.renderInput()
        ),
        this.renderIcon(),
        this.renderHelp()
      ])
    ] : this.renderWrapper([
      this.renderCheckboxAndRadioWrapper(
        this.renderLabel(
          this.renderInput(),
          this.renderInputHelper()
        )
      ),
      this.renderHelp()
    ]);
  };

  render() {
    let children = this.renderChildren();
    return this.renderFormGroup(children);
  }
}
